import { shape_square } from "./drawing-shapes";
import { DrawShapeBaseAdvancedModule } from "../../ModuleBase/shape-base-advanced-module";

export class DrawShapesSqreModule extends DrawShapeBaseAdvancedModule {
	constructor(canvas, getColor, drawingHistory) {
		super(canvas, getColor, drawingHistory);

		this.name = "sqre";
		this.icon = shape_square;

		this._getInitialShape = pointer => {
			return new fabric.Rect({
				left: pointer.x,
				top: pointer.y,
				width: 0,
				height: 0,
				fill: this.transpColor,
				strokeWidth: 2,
				stroke: this.__getColor(),
				selectable: false
			})
		}

		this._resizeShape = (e) => {
			const pointer = this.canvas.getPointer(e);
			const diffX = (pointer.x - this.startPosition.x);
			const diffY = (pointer.y - this.startPosition.y);
			let left, top, side = (Math.abs(diffX) + Math.abs(diffY)) / 2;
			if (diffX >= 0 && diffY >= 0) {
				// left top -> right bottom
				left = this.startPosition.x;
				top = this.startPosition.y;
			} else if (diffX < 0 && diffY < 0) {
				// right bottom -> left top
				left = this.startPosition.x - side;
				top = this.startPosition.y - side;
			} else if (diffX < 0) {
				// right top -> left bottom
				left = this.startPosition.x - side;
				top = this.startPosition.y;
			} else if (diffY < 0) {
				// left bottom -> right top
				left = this.startPosition.x;
				top = this.startPosition.y - side;
			}
			this.shape.set({ left, top, width: side, height: side });
		}
	}
}

window.customElements.define(
	"inspx-draw-shapes-sqre-module",
	DrawShapesSqreModule
);
